function numOrNull(v) {
  if (v == null || v === "") return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

export function serializeCartForOrder(cart, config) {
  const ttcKey = config.itemPriceFieldTTC;
  const htKey = config.itemPriceFieldHT;
  return cart.map((item) => {
    const f = item.meal.fields;

    return {
      id: item.meal.id,
      name: f.Name ?? null,
      quantity: item.quantity,
      priceTTC: numOrNull(f[ttcKey]),
      priceHT: numOrNull(f[htKey]),
      cataloguePriceTTC: numOrNull(f.cataloguePriceTTC),
      cataloguePriceHT: numOrNull(f.cataloguePriceHT),
      priceOverrideTTC: numOrNull(f.priceOverrideTTC),
      priceOverrideHT: numOrNull(f.priceOverrideHT),
    };
  });
}
